import home from "../components/index/home.vue";
import about from "../components/about/about.vue";
import detail from "../components/detail/detail.vue";
import video__detail from "../components/video/video_detail.vue";
import video__list from "../components/video/video_list.vue";
import list from "../components/productList/productList.vue";
import login from "../components/user/login.vue";
import profile from "../components/user/profile.vue";
import shop from "../components/shop/shop.vue";
import special from "../components/specialOffer/special.vue";
import sale from "../components/spcialSale/sale.vue";
import brand from "../components/brand/brand.vue";
import forgot from "../components/user/forgot.vue";
import userdetail from "../components/user/userDetail/detail.vue";
import adress from "../components/user/userDetail/adress.vue";
import passchange from "../components/user/userDetail/passchange.vue";
import shopping from "../components/shop/shopping.vue";
import fav from "../components/user/userDetail/favlist.vue";
import order from "../components/user/userDetail/myorder.vue";
import orderdetail from "../components/user/userDetail/myorderdetail.vue";
import kif from "../components/user/userDetail/kif.vue";
import kifp from "../components/user/userDetail/kifp.vue";
import contact from "../components/contact/contact_us.vue";
import service from "../components/tools/tools.vue";
import enteghad from "../components/enteghad/contact_us.vue";
import rules from "../components/rules/rules.vue";
import download from "../components/download/download.vue";
// import about from '../components/about/about.vue'
import question from "../components/QA/question.vue";
import newest from "../components/newest/newest.vue";
import voice from "../components/voice/voice.vue";
import hiddenCat from "../components/hiddenCat/hiddenCat.vue";

export const routes = [
  { path: "/", component: home },
  // { path: '*', redirect: '/' },
  { path: "/about", component: about },
  { path: "/product/detail/" + ":id", component: detail, name: "detail" },
  { path: "/product/cat/" + ":id", component: list, name: "list" },
  { path: "/product/brand/" + ":id", component: brand, name: "brand" },
  { path: "/special-offer", component: special, name: "special" },
  { path: "/products/newest", component: newest, name: "newest" },
  { path: "/products/" + ":id", component: hiddenCat, name: "hiddenCat" },
  { path: "/download", component: download, name: "download" },
  { path: "/special-sale", component: sale, name: "sale" },
  { path: "/user/forgot-password", component: forgot, name: "forgot" },
  { path: "/login", component: login, name: "login" },
  {
    path: "/video/detail/playlist" + ":id" + "/index/" + ":num",
    component: video__detail,
    name: "video_detail",
  },
  { path: "/video/list", component: video__list, name: "video_list" },
  { path: "/complaints", component: enteghad, name: "complaints" },
  { path: "/contact-us", component: contact, name: "contact" },
  { path: "/rules", component: rules, name: "rules" },
  { path: "/services", component: service, name: "service" },
  { path: "/questions", component: question, name: "question" },
  { path: "/voice/" + ":id", component: voice, name: "voice-page" },
  {
    path: "/profile",
    component: profile,
    name: "profile",
    children: [
      { path: "", component: userdetail },
      { path: "/profile/address", component: adress },
      { path: "/profile/pass-change", component: passchange },
      { path: "/profile/favlist", component: fav },
      { path: "/profile/myorder", component: order },
      {
        path: "/profile/myorder/detail/" + ":id",
        name: "orderdea",
        component: orderdetail,
      },
      { path: "/profile/withdrawlist", component: kif },
      { path: "/profile/withdraw", component: kifp },
    ],
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cart",
    component: shop,
    name: "shop",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/shopping",
    component: shopping,
    name: "shopping",
    meta: {
      requiresAuth: true,
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes.js